// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bar{height:calc(100% - 40px)}.time_line{display:flex;padding-right:10px;justify-content:space-between;margin:10px 40px 0 24px;height:1px;background:#999;color:#999;position:relative}.time_line span{position:absolute;top:5px;margin-left:-10px}.time_line span:before{content:\"|\";width:1px;color:#999;position:relative;top:-20px;left:9px}", ""]);
// Exports
module.exports = exports;
